import script from "./ProductTypePage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductTypePage.vue?vue&type=script&setup=true&lang=js"

import "./ProductTypePage.vue?vue&type=style&index=0&id=223f6aa8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-223f6aa8"]])

export default __exports__